import { gql } from '@apollo/client';

export const SAVE_DOCUMENT_TYPE_WITH_ALLOWED_STATES = gql`
  mutation removeOrUpdateDocumentTypeWithAllowedStates(
    $documentTypeId: Int
    $allowedStatesPermissions: [AllowedStatePermissionInput]
    $deletedAllowedStates: [Int]
  ) {
    removeOrUpdateDocumentTypeWithAllowedStates(
      documentTypeId: $documentTypeId
      allowedStatesPermissions: $allowedStatesPermissions
      deletedAllowedStates: $deletedAllowedStates
    ) {
      commandId
      correlationId
    }
  }
`;

export const EXPORT_DOCUMENT_ALLOWED_STATE_RIGHTS_LIST = gql`
  mutation exportDocumentAllowedStateRights($documentTypeId: Int!, $fileType: String) {
    exportDocumentAllowedStateRights(documentTypeId: $documentTypeId, fileType: $fileType) {
      fileId
      fileName
      filePath
      fileBytes
    }
  }
`;

export const IMPORT_DOCUMENT_ALLOWED_STATE_RIGHTS = gql`
  mutation importDocumentAllowedStateRights($documentTypeId: Int!, $file: Upload!) {
    importDocumentAllowedStateRights(documentTypeId: $documentTypeId, file: $file) {
      commandId
    }
  }
`;
